
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11.99 2C6.468 2.006 1.996 6.485 2 12.007c.004 5.521 4.482 9.995 10.003 9.993C17.525 21.998 22 17.522 22 12A10 10 0 0011.99 2zM12 20a8 8 0 110-16 8 8 0 010 16zm-.22-13h-.06a.717.717 0 00-.72.72v4.72a.99.99 0 00.49.86l4.15 2.49a.715.715 0 00.73-1.23l-3.87-2.3V7.72a.717.717 0 00-.72-.72z","opacity":".48"}})])
          )
        }
      }
    